import React, { useState, useEffect, useMemo } from "react";
import { Form, Container, Row, Col, Button } from "react-bootstrap";
import { PacmanLoader } from "react-spinners";
import LeaseList from "containers/property/LeaseList";
import Select from 'react-select';
import { get } from "aws-amplify/api";
import { createElementIdFactory } from "utils/elementIds";
import "containers/common/List.css";
import "containers/common/Table.css";

function LeaseSearch({ 
        user,
        isAuthenticated,
        saveRecord,
        updateTableState,
        deleteRecord,
        refreshDataSet,
        validateRelatedRecord }) {

    const archiveOptions = [{ value: false, label: "Exclude archived" }, { value: true, label: "Archived only" }, { value: null, label: "All leased including archived" }];
    const [isLoading, setIsLoading] = useState(false);
    const [leases, setLeases] = useState([]);
    const [archived, setArchived] = useState(false);
    const [formData, setFormData] = useState({
        propertyid: "",
        name: "",
        state: "",
        leasenumber: "",
        selectedArchiveOption: { value: false, label: "Exclude archived" }
    });
    const createId = useMemo(() => createElementIdFactory("lease-search"), []);


  // --- Data Fetching and Update Functions ---

    useEffect(() => {
        console.log("LeaseSearch");
        if (!isAuthenticated) {
            // if false
            return;
        }
        document.title = "Cityscope Lease Search";
    }, [isAuthenticated]);


    //API
    async function getLeases(filter) {
        console.log("Inside getLeases()");

        console.log(filter);
        const options = {
            queryParams: filter,
        };
        const response = await get({
            apiName: "colin",
            path: "/leases",
            options,
        }).response;
        try {
            const apiLeases = await response.body.json();
            console.log("API Leases: ", apiLeases);
            return apiLeases;
        } catch (error) {
            alert(error + ". Please refresh the page (F5) to try again.");
        }
    }


    function handleFieldChange(e) {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    }

    function clearFilters() {
        setFormData({
            propertyid: "",
            name: "",
            state: "",
            leasenumber: "",
            selectedArchiveOption: { value: false, label: "Exclude archived" }
        });
        setArchived(false);
    }


    function handleArchiveChange(selectedArchiveOptionVar) {
        setFormData((previousFormData) => ({
            ...previousFormData,
            selectedArchiveOption: selectedArchiveOptionVar,
        }));
        if (selectedArchiveOptionVar) {
            setArchived(selectedArchiveOptionVar.value);
        }
        else {
            setArchived(null);
        }
    }


    async function handleSubmit(event) {
        event.preventDefault();
        setIsLoading(true);
        try {
            // Build filter: omit empty strings so the backend treats them as "no filter"
            const filter = {};
            if (formData.propertyid) filter.propertyid = formData.propertyid;
            if (formData.name) filter.name = formData.name;
            if (formData.leasenumber) filter.leasenumber = formData.leasenumber;
            if (formData.state) filter.state = formData.state;
            // Backend expects archived as string "True"; empty string means no archived filter.
            if (archived === true) {
                filter.archived = "True";
            } else if (archived === false) {
                filter.archived = "False";
            } else {
                filter.archived = "";
            }
            const resLeases = await getLeases(filter);
            if (resLeases && Array.isArray(resLeases)) {
                resLeases.sort((a, b) => (a.lessee_trading > b.lessee_trading) ? 1 : ((b.lessee_trading > a.lessee_trading) ? -1 : 0));
                setLeases(resLeases);
            }
        } catch (e) {
            alert(e + ". Please refresh the page (F5) to try again.");
        } finally {
            setIsLoading(false);
        }
    }


  // --- Render Functions ---

    function renderLeases() {
        return (
            <Container id={createId("page")} fluid>
                <Row id={createId("header-row")}>
                    <Col sm={12} md={12} lg={12}>
                        <h6 id={createId("title")}>Cityscope Lease Search</h6>
                    </Col>
                </Row>
                <Form className="LeaseSearchFilterForm" id={createId("form")} onSubmit={handleSubmit}>
                    <Row id={createId("filter-row")}>
                        <Col>
                            <Form.Group>
                                <Form.Control
                                    id={createId("input-property-id")}
                                    name="propertyid"
                                    value={formData.propertyid}
                                    onChange={handleFieldChange}
                                    as="input"
                                    type="text"
                                    placeholder="Cityscope Reference starting"
                                />
                            </Form.Group>
                        </Col>
                        <Col >
                            <Form.Group>
                                <Form.Control
                                    id={createId("input-name")}
                                    name="name"
                                    type="text"
                                    value={formData.name}
                                    onChange={handleFieldChange}
                                    placeholder="Tenant Name starting"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Control
                                    id={createId("input-lease-number")}
                                    name="leasenumber"
                                    type="text"
                                    value={formData.leasenumber}
                                    onChange={handleFieldChange}
                                    placeholder="Lease No. containing"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Control
                                    id={createId("input-state")}
                                    name="state"
                                    type="text"
                                    value={formData.state}
                                    onChange={handleFieldChange}
                                    placeholder="State"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Select
                                    inputId={createId("select-archived")}
                                    value={formData.selectedArchiveOption}
                                    onChange={handleArchiveChange}
                                    options={archiveOptions}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            <div className="d-flex gap-2">
                                <Button id={createId("button-search")} type="submit">Search</Button>
                                <Button id={createId("button-clear")} type="button" onClick={clearFilters}>Clear Filters</Button>
                            </div>
                        </Col>
                    </Row>
                </Form>

                {isLoading && (
                    <div id={createId("loading-container")} className="outer-div">
                        <div className="sweet-loading inner-div">
                            <PacmanLoader
                                cssOverride={{ display: "block", margin: "0 auto" }}
                                size={20}
                                color="#e03c31"
                                loading={isLoading}
                            />
                        </div>
                    </div>
                )}

                {!isLoading && (
                    <Row id={createId("results-row")}>
                        <Col id={createId("results-col")}>
                            <LeaseList
                                isAuthenticated={isAuthenticated}
                                user={user}
                                data={leases}
                                updateTableState={updateTableState}
                                saveRecord={saveRecord}
                                deleteRecord={deleteRecord}
                                refreshDataSet={refreshDataSet}
                                validateRelatedRecord={validateRelatedRecord}
                                propertyid={formData.propertyid}
                                controlType="table2"
                            />
                        </Col>
                    </Row>
                )}
            </Container>
        );
    }
    return (
        <div id={createId("root")} className="LeaseSearch">
            {isAuthenticated ? renderLeases() : null}
        </div>
    );
}

export default LeaseSearch;